/**
 * shapes - annotation domain types shared by the op log and its renderers (D-08).
 *
 * Pure types plus the two fixed constant palettes; no logic lives here.
 */

export type Tool = "arrow" | "rect" | "freehand";

export const SHAPE_COLORS = ["#ef4444", "#facc15", "#22c55e", "#3b82f6", "#ffffff"] as const; // red, yellow, green, blue, white

export const STROKE_WIDTHS = [2, 4, 8] as const; // thin, medium, thick; units of 1/1000 of the content width
export type StrokeWidth = 2 | 4 | 8;

// 0..1 against the unmirrored canonical source (D-05).
export type NormPointTuple = [number, number];

export type ShapeGeometry = {
  points: NormPointTuple[];
  color: string;
  width: StrokeWidth;
};

export type Shape = ShapeGeometry & {
  id: string;
  tool: Tool;
  authorIdentity: string;
};

export type OpKind = "ShapeAdd" | "ShapeUpdate" | "ShapeDelete" | "ShapeRestore";

export type ShapeAddPayload = { shape: ShapeGeometry & { id: string; tool: Tool } };
export type ShapeUpdatePayload = { shapeId: string; before: ShapeGeometry; after: ShapeGeometry };
export type ShapeIdsPayload = { shapeIds: string[] }; // ShapeDelete and ShapeRestore

export type OpPayload = ShapeAddPayload | ShapeUpdatePayload | ShapeIdsPayload;

export type SyncOp = {
  opId: string;
  frameId: string;
  kind: OpKind;
  payload: OpPayload;
  authorIdentity: string;
  undoOf: string | null;
  redoOf: string | null;
  seq: number | null;
};

export type OpDraft = {
  frameId: string;
  kind: OpKind;
  payload: OpPayload;
  undoOf: string | null;
  redoOf: string | null;
};
